import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../../context/ThemeContext";
import img4 from "../../../assets/Sale.png";
import img5 from "../../../assets/ledger.png";
import img6 from "../../../assets/invoice.png";
import "../../../pages/Landing/LandingPage.css";

const Overview = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <section
      className={`overview-section py-5 ${darkMode ? "dark-mode" : ""}`}
      id="overview"
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="overview-main-title">
              Comprehensive Platform Features
            </h2>
            <p className="overview-subtitle">
              Explore our powerful tools designed to streamline your accounting
              processes and boost productivity
            </p>
          </div>
        </div>

        <div className="row g-5 py-5 align-items-center overview-item">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="overview-img-container">
              <img
                className="img-fluid rounded shadow"
                src={img4}
                alt="Sales Management"
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div
              className={`overview-content ${
                darkMode ? "dark-overview-content" : ""
              }`}
            >
              <div className="d-flex align-items-center mb-4">
                <h1 className="mb-0" style={{ color: "#00d389" }}>
                  01
                </h1>
                <span
                  className="mx-2"
                  style={{
                    width: "30px",
                    height: "2px",
                    backgroundColor: "#00d389",
                  }}
                ></span>
                <h5 className="mb-0" style={{ color: "#00d389" }}>
                  Sales Management
                </h5>
              </div>
              <p
                className={`mb-4 ${darkMode ? "dark-mode-text-secondary" : ""}`}
              >
                Manage your entire sales process from start to finish with our
                comprehensive suite of tools. Create professional quotes,
                convert them to orders, generate invoices, and process credit
                notes all within a seamless workflow.
              </p>
              <div
                className={`overview-features ${
                  darkMode ? "dark-overview-features" : ""
                }`}
              >
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Quote-to-invoice conversion
                  </span>
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Automated order processing
                  </span>
                </p>
                <p className="mb-0">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Credit note management
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-5 py-5 align-items-center flex-column-reverse flex-lg-row overview-item">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div
              className={`overview-content ${
                darkMode ? "dark-overview-content" : ""
              }`}
            >
              <div className="d-flex align-items-center mb-4">
                <h1 className="mb-0" style={{ color: "#00d389" }}>
                  02
                </h1>
                <span
                  className="mx-2"
                  style={{
                    width: "30px",
                    height: "2px",
                    backgroundColor: "#00d389",
                  }}
                ></span>
                <h5 className="mb-0" style={{ color: "#00d389" }}>
                  Purchase & Vendor Management
                </h5>
              </div>
              <p
                className={`mb-4 ${darkMode ? "dark-mode-text-secondary" : ""}`}
              >
                Take control of your purchasing process with our comprehensive
                tools. Create purchase requisitions, compare vendor quotes,
                generate purchase orders, process bills, and handle returns
                efficiently.
              </p>
              <div
                className={`overview-features ${
                  darkMode ? "dark-overview-features" : ""
                }`}
              >
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Vendor database & management
                  </span>
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Complete purchase cycle
                  </span>
                </p>
                <p className="mb-0">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Purchase analytics & insights
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="overview-img-container">
              <img
                className="img-fluid rounded shadow"
                src={img5}
                alt="Purchase & Vendor Management"
              />
            </div>
          </div>
        </div>

        <div className="row g-5 py-5 align-items-center overview-item">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="overview-img-container">
              <img
                className="img-fluid rounded shadow"
                src={img6}
                alt="Financial Reporting"
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div
              className={`overview-content ${
                darkMode ? "dark-overview-content" : ""
              }`}
            >
              <div className="d-flex align-items-center mb-4">
                <h1 className="mb-0" style={{ color: "#00d389" }}>
                  03
                </h1>
                <span
                  className="mx-2"
                  style={{
                    width: "30px",
                    height: "2px",
                    backgroundColor: "#00d389",
                  }}
                ></span>
                <h5 className="mb-0" style={{ color: "#00d389" }}>
                  Comprehensive Reporting
                </h5>
              </div>
              <p
                className={`mb-4 ${darkMode ? "dark-mode-text-secondary" : ""}`}
              >
                Make informed business decisions with our powerful reporting
                tools. Generate detailed financial statements, analyze sales and
                purchase trends, track tax obligations, and monitor customer
                payment patterns.
              </p>
              <div
                className={`overview-features ${
                  darkMode ? "dark-overview-features" : ""
                }`}
              >
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Profit & loss statements
                  </span>
                </p>
                <p>
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Balance sheets & tax reports
                  </span>
                </p>
                <p className="mb-0">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{ color: "#00d389" }}
                    className="me-3"
                  />
                  <span className={darkMode ? "dark-mode-text" : ""}>
                    Customer aging analysis
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
